<template>
  <!-- The loader owns its own position so every page shows it in the same place.
       `page` pins it to the middle of the screen whatever wraps it: ion-page's
       `contain: layout` makes the page the containing block, so `fixed` centres on
       the page even from deep inside ion-content. pointer-events-none keeps the
       back button and header usable while it shows. `inline` is for a loader that
       belongs under a form or button, in the flow. -->
  <div
    class="flex items-center justify-center gap-[10px]"
    :class="variant === 'page' ? 'fixed inset-0 z-10 pointer-events-none' : 'w-full py-[16px]'"
    role="status"
    aria-label="Loading"
    data-test="loading-state"
  >
    <span
      v-for="n in 3"
      :key="n"
      class="loading-dot h-[15px] w-[15px] rounded-full bg-orange-500"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    variant: {
      type: String,
      default: 'page',
      validator: value => ['page', 'inline'].includes(value),
    },
  },
};
</script>

<style scoped>
.loading-dot {
  animation: loading 1s linear infinite;
}

.loading-dot:nth-child(1) {
  animation-delay: 0.1s;
}

.loading-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes loading {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(15px);
  }

  50% {
    transform: translateX(-15px);
  }

  100% {
    transform: translateX(0);
  }
}
</style>
